import { HOST_POS } from "config";

const apiUrl: string = HOST_POS
const call = (ep: string, method: string, data: any = []) =>
    new Promise((res, rej) => {
        fetch(`${apiUrl}/${ep}`, {
            method,
            headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
            ...(method !== "GET" ? { body: JSON.stringify(data) } : {}),
        }).then((e) => e.json())
            .then((data) => res(data))
            .catch((err) => rej(err));
    });
export const getCompany = () => call('company', 'GET')
export const addItem = (item: object) => call('company/item', 'POST', {

    item
})
export const updateItem = (id: string, item: object) => call(`company/item/${id}`, 'POST', {

    item,
    id
})
export const deleteItem = (id: string) => call(`company/item/${id}`, 'DELETE', {
    id
})
export interface ApiResponse {
    code: string;
    message: string;
    status: number;
}
export const checkCrc = (email: string, uniqueIdentifier: string) => call(`check`, 'POST', { email, uniqueIdentifier })
export const checkStatus = (email: string): Promise<ApiResponse> => call('status', 'POST', { email }) as Promise<ApiResponse>
